import { Box } from "@mui/material";
import { Outlet } from "react-router-dom";
import Header from "../../components/Header/Header";
import ScrollToTop from "../../components/ScrollToTop/ScrollToTop";

const HeaderLayout = ({ children }) => {
  return (
    <>
      <ScrollToTop />
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          height: "100vh",
        }}
      >
        <Header />
        <Box
          sx={{
            display: "flex",
            flex: 1,
            overflow: "hidden",
          }}
        >
          <Box
            data-scroll-container
            sx={{
              flex: 1,
              overflow: "auto",
            }}
          >
            {children || <Outlet />}
          </Box>
        </Box>
      </Box>
    </>
  );
};

export default HeaderLayout;
